<div [class]="! fromRoute ? 't-popup popup-graphs' : ''" style='display: block;height:100%'>

    <div [class]="! fromRoute ? 'popup-close' : ''" (click)="closed.next()"></div>

    <div [class]="! fromRoute ? 'popup-frame' : ''">
      
        <div class="popup-body" *ngIf="pathologies && pathologies.length > 0" style="direction: rtl;">
          <button type="button" class="btn btn-primary" style="margin: 10px 0; float: left;" (click)="printPopupBody()">print</button>

          <div style="display: flex; font-size: 13pt;">
            <h2>טופס ריכוז דגימות ביופסיה/תעודת משלוח מס. {{inventoryId}}
            <br>
            מעבדה: {{getLabName()}}
            <br>
            תאריך: {{currentDate | date:'dd/MM/yyyy'}}
          </h2>
          <img src="/api/logo" style="max-height: 10em; max-width: 15em;margin-right: 1em;"/>
          </div>
          
          <table class="pretty-table" style="direction: rtl;">
            <tr >
                <td>#</td>
                <td >מטופל</td>
                <td>Barcode(s)</td>
                <td>מס. דגימות גסטרו</td>
                <td>מס. דגימות קולונו</td>
                <td>חתימת אח/ות</td>
                <td>חתימת מזכירה</td>
            </tr>

            <tr *ngFor="let group of groupedPathologies; index as i">
              <td>{{i+1}}</td>
              <td>
                ת.ז.: {{ getDisplayId(group.pathologies[0].ID) }} <br>
                שם: {{ (group.pathologies[0].First || '') + ' ' + (group.pathologies[0].Last || '') }} <br>
                גורם מימון: {{group.pathologies[0].HMO }} <br>          
                <br>
                מס' מבחנות: {{group.pathologies.length}}
              </td>
              <td>
                <ng-container *ngFor="let path of group.pathologies">
                  <app-barcode [value]="path.BarCode" style="max-width: 20vw;"></app-barcode>
                  <br>
                </ng-container>
              </td>
              <td>{{group.pathologies[0].ExamType == 'Gastroscopy'? group.pathologies.length : ''}}</td>
              <td>{{group.pathologies[0].ExamType == 'Colonoscopy'? group.pathologies.length : ''}}</td>
              <td>
                {{group.pathologies[0].NurseSignature? group.pathologies[0].NurseSignature : ''}}
                <button style="background-color: #dcb16b;" *ngIf="!group.pathologies[0].NurseSignature && loginService.userType === 'nurse'" (click)="signDetails(group.pathologies)">Sign that details are correct</button>
              </td>
              <td>
                {{group.pathologies[0].SecretarySignature? group.pathologies[0].SecretarySignature : ''}}
                <button style="background-color: #dcb16b;" *ngIf="!group.pathologies[0].SecretarySignature && loginService.userType === 'secretary'" (click)="signDetails(group.pathologies)">Sign that details are correct</button>
              </td>
            </tr>
            <tr>
              <td></td>
              <td>סה"כ</td>
              <td></td>
              <td>{{gastroct}}</td>
              <td>{{colonoct}}</td>
              <td></td>
              <td></td>
            </tr>
          </table>
          
          <p style="margin-top: 2em;" *ngIf="nurseSigningDate">
            בדקתי את פרטי המשלוח ומצאתי אותם תקינים
            <br>
             נחתם על ידי אח/ות: {{groupedPathologies[0].pathologies[0].NurseSignature}} בתאריך: {{nurseSigningDate || currentDate | date:'dd/MM/yyyy'}}
          </p>

          <p style="margin-top: 2em;" *ngIf="secretarySigningDate">
            בדקתי את פרטי המשלוח ומצאתי אותם תקינים
            <br>
             נחתם על ידי מזכירה: {{groupedPathologies[0].pathologies[0].SecretarySignature}} בתאריך: {{secretarySigningDate || currentDate | date:'dd/MM/yyyy'}}
          </p>
         
          <button *ngIf="! signed && loginService.userType == 'nurse' && nurseSigned()" (click)="signInventory()" style="background: #dcb16b; color: white">
            בדקתי את פרטי המשלוח ומצאתי אותם תקינים
            <br>
            שלח דוח למזכירה
          </button>

          <button *ngIf="! signed && loginService.userType == 'secretary' && secretarySigned() && ! secretarySigningDate" (click)="signInventory()" style="background: #dcb16b; color: white">
            בדקתי את פרטי המשלוח ומצאתי אותם תקינים
          </button>
           

          <!-- Messenger signature pane -->
          <div *ngIf="loginService.userType == 'secretary' && secretarySigningDate" style="margin-top:2em;">
            <label for="messenger-signature">חתימת שליח מעבדה:</label>
            <div style="border:1px solid #ccc; width:350px; height:120px; background:#fff; position:relative;">
              <canvas #signaturePad width="350" height="120" style="touch-action: none; width:100%; height:100%;"></canvas>
              <button type="button" style="position:absolute;top:2px;right:2px;" (click)="clearMessengerSignature()">נקה</button>
            </div>
            <input type="text" [(ngModel)]="messengerName" placeholder="הקלד שם שליח" style="margin-top:10px; width:350px;" />
            <br>
            <button (click)="messengerSign()" style="background: #dcb16b; margin-top:10px; width:350px; color: white"
              [disabled]="!messengerName || !messengerSignature" *ngIf="! signing">
               הריני לאשר שבדקתי ומצאתי את פרטי המשלוח נכונים ומתאימים.
            </button>
          </div>
          <div *ngIf="messengerSignedDate" style="margin-top:2em;">
            <p>חתימת השליח :</p>
            <p>תאריך: {{messengerSignedDate | date:'dd/MM/yyyy'}}</p>
            <p>שם: {{messengerName}}</p>
            <p>חתימה:</p>
            <img src="/api/lab/messengerSignature/{{inventoryId}}" alt="Messenger Signature" style="max-width: 100%; height: auto;" />
          </div>

  </div>
</div>